import { TwoFAContainer } from 'src/containers/Authentication';
import { AuthShell, AuthHeading } from 'src/components/Layout';
import { usePageMeta } from 'src/hooks';

const TwoFAPage = () => {
  usePageMeta('Two-step verification');

  return (
    <AuthShell>
      <AuthHeading
        title="Two-step verification"
        description="Enter the 6-digit code from your authenticator app to sign in."
      />
      <TwoFAContainer />
    </AuthShell>
  );
};

export default TwoFAPage;
